import ChargeHelper from 'features/Charge/chargeHelper';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import AppColors from 'general/constants/AppColors';
import AppRoute from 'general/constants/AppRoute';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';

DialogTransactionDetailView.propTypes = {
  item: PropTypes.object.isRequired,
  user: PropTypes.object,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogTransactionDetailView({ item, onCancel, onDone, user }) {
  // MARK: ---- PROPERTIES ----
  const row = item;

  return (
    <div className="p-4" style={{ backgroundColor: AppColors.gray[100] }}>
      {UIHelper.buildSectionCard(
        <div
          className=""
          style={{
            backgroundColor: 'white',
            borderRadius: '5px',
            overflow: 'hidden',
          }}
        >
          {Utils.isValid(item?.paymentId) ? (
            <>
              {UIHelper.buildCardCellItem(
                'Mã giao dịch',
                row?.paymentCode ?? row?.paymentId,
              )}
              {UIHelper.buildCardCellItem(
                'Lượng điện đã sạc',
                (!_.isNil(row?.energy) ? Utils.formatNumber((row?.energy / 1000).toFixed(3)) : '') + ' kWh'
              )}
              {UIHelper.buildCardCellItem(
                'Số tiền sạc',
                (!_.isNil(row?.amount) ? '-' + Utils.formatNumber(row?.amount) : '') + ' VNĐ',
                null,
                true,
                AppColors.danger
              )}
              {UIHelper.buildCardCellItem(
                'Phương thức thanh toán',
                row?.paymentMethod
                  ? _.find(
                    ChargeHelper.Data.chargePaymentMethodOptions,
                    (item) => item.value === row?.paymentMethod
                  )?.name
                  : ''
              )}
              {UIHelper.buildCardCellItem(
                'Thời gian bắt đầu',
                !_.isNil(row?.time)
                  ? Utils.formatDateTimeToString(row?.time, 'DD/MM/YYYY - HH:mm')
                  : ''
              )}
              {UIHelper.buildCardCellItem(
                'Thời gian kết thúc',
                !_.isNil(row?.time)
                  ? Utils.formatDateTimeToString(row?.time, 'DD/MM/YYYY - HH:mm')
                  : ''
              )}
              {UIHelper.buildCardCellItem(
                'Biển số xe',
                row?.plate
              )}
              {/* {UIHelper.buildCardCellItem(
                'Phiên sạc',
                !_.isNil(row?.transactionId) ? 'Xem chi tiết' : '',
                () => {
                  if (!_.isNil(row?.transactionId)) {
                    Utils.openInNewTab(`${AppRoute.chargeTransactionList}/${row?.transactionId}`);
                  }
                }
              )} */}
              {UIHelper.buildCardCellItem(
                'Trạng thái',
                <KTLabel
                  text={ChargeHelper.Utils.getPaymentStatusName(row?.status)}
                  isInline={true}
                  size={KTLabelSize.medium}
                  additionalClassName={`label-light-${ChargeHelper.Utils.getPaymentStatusColor(
                    row?.status
                  )}`}
                />,
                null,
                false
              )}
            </>
          ) :
            Utils.isValid(item?.transactionId) ? (
              <>
                {UIHelper.buildCardCellItem(
                  'Mã phiên sạc',
                  row?.transactionCode ?? row?.transactionId,
                )}
                {UIHelper.buildCardCellItem(
                  'Lượng điện đã sạc',
                  (!_.isNil(row?.energy) ? Utils.formatNumber((row?.energy / 1000).toFixed(3)) : '') + ' kWh'
                )}
                {UIHelper.buildCardCellItem(
                  'Số tiền sạc',
                  (!_.isNil(row?.totalCost) ? '-' + Utils.formatNumber(row?.totalCost) : '') + ' VNĐ',
                  null,
                  true,
                  AppColors.danger
                )}
                {UIHelper.buildCardCellItem(
                  'Số tiền trả trước',
                  (!_.isNil(row?.prepaidAmount) ? '-' + Utils.formatNumber(row?.prepaidAmount) : '') + ' VNĐ',
                  null,
                  true,
                  AppColors.danger
                )}
                {UIHelper.buildCardCellItem(
                  'Phương thức thanh toán',
                  'Ví điện tử',
                )}
                {UIHelper.buildCardCellItem(
                  'Thời gian bắt đầu',
                  !_.isNil(row?.startTime)
                    ? Utils.formatDateTimeToString(row?.startTime, 'DD/MM/YYYY - HH:mm')
                    : ''
                )}
                {UIHelper.buildCardCellItem(
                  'Thời gian kết thúc',
                  !_.isNil(row?.endTime)
                    ? Utils.formatDateTimeToString(row?.endTime, 'DD/MM/YYYY - HH:mm')
                    : ''
                )}
                {UIHelper.buildCardCellItem(
                  'Biển số xe',
                  row?.plate
                )}
                {/* {UIHelper.buildCardCellItem(
                'Phiên sạc',
                !_.isNil(row?.transactionId) ? 'Xem chi tiết' : '',
                () => {
                  if (!_.isNil(row?.transactionId)) {
                    Utils.openInNewTab(`${AppRoute.chargeTransactionList}/${row?.transactionId}`);
                  }
                }
              )} */}
                {UIHelper.buildCardCellItem(
                  'Trạng thái',
                  <KTLabel
                    text={ChargeHelper.Utils.getChargeTransactionStatusName(row?.status)}
                    isInline={true}
                    size={KTLabelSize.medium}
                    additionalClassName={`label-light-${ChargeHelper.Utils.getChargeTransactionStatusColor(
                      row?.status
                    )}`}
                  />,
                  null,
                  false
                )}
              </>
            )
              : (
                <>
                  {UIHelper.buildCardCellItem(
                    'Mã giao dịch',
                    row?.walletTransactionCode ?? row?.walletTransactionId?.toString(),
                  )}
                  {UIHelper.buildCardCellItem(
                    'Mã giao dịch tham chiếu',
                    row?.externalTransactionCode ?? row?.externalTransactionId,
                  )}
                  {/* {UIHelper.buildCardCellItem('Khách hàng', row?.wallet?.user?.fullname, () => {
                Utils.openInNewTab(`${AppRoute.customerList}/${row?.wallet?.userId}`);
              })} */}
                  {UIHelper.buildCardCellItem(
                    'Loại giao dịch',
                    ChargeHelper.Utils.getDriverTransactionName(row?.fundingSource),
                  )}
                  {UIHelper.buildCardCellItem(
                    'Số tiền',
                    !_.isNil(row?.amount)
                      ? (_.toNumber(row?.amount) > 0 ? '+' : '') + Utils.formatNumber(row?.amount) + ' VNĐ'
                      : '',
                    null,
                    true,
                    _.toNumber(row?.amount) > 0 ? AppColors.primary : AppColors.danger,
                  )}
                  {UIHelper.buildCardCellItem(
                    'Thời gian',
                    !_.isNil(row?.time)
                      ? Utils.formatDateTimeToString(row?.time, 'DD/MM/YYYY - HH:mm')
                      : ''
                  )}
                  {UIHelper.buildCardCellItem(
                    'Phương thức thanh toán',
                    _.find(
                      ChargeHelper.Data.chargePaymentMethodOptions,
                      (item) => item.value === row?.fundingSource
                    )?.name
                  )}
                  {UIHelper.buildCardCellItem('Nội dung', row?.description)}
                  {UIHelper.buildCardCellItem(
                    'Trạng thái giao dịch',
                    <KTLabel
                      text={ChargeHelper.Utils.getWalletTransactionStatusName(row?.status)}
                      isInline={true}
                      size={KTLabelSize.medium}
                      additionalClassName={`label-light-${ChargeHelper.Utils.getWalletTransactionStatusColor(
                        row?.status
                      )}`}
                    />,
                    null,
                    false
                  )}
                </>
              )}
        </div>
      )}
    </div>
  );
}

export default DialogTransactionDetailView;
